// extracted by mini-css-extract-plugin
export default {"add-quest-wrap":"AllQuestions_add-quest-wrap__5C0iD","outerwrap":"AllQuestions_outerwrap__1lRna","list-outer-wrap":"AllQuestions_list-outer-wrap__HQBF7"};